<template>
  <div id="reservation" v-show="viewShow">
    <!-- 头部 -->
    <!--      <yy-header>填写预约信息</yy-header>-->
    <div class="main">
      <div class="res-content">
        <h3 class="matter">{{ itemName }}</h3>
        <div class="location">{{ placeName }}</div>
        <div class="address">地址：{{ placeAddress }}</div>
        <!-- <div class="res-item">
          <div class="item-tit"><span class="icon"><img src="../assets/img/icon01.png" alt=""></span>预约须知</div>
          <a @click="toNotice"><p class="one-txt-cut">1、预约后不到现场/取号后不到窗口办理，都属于爽哈哈哈哈哈</p><span><img src="../assets/img/arrow-right.png" alt=""></span></a>
        </div> -->
        <div class="res-item">
          <div class="item-tit"><span class="icon"><img src="../assets/img/icon02.png" alt=""></span>工作时间</div>
          <div>{{ workTime }}</div>
        </div>
      </div>
      <h3 class="title">预约信息</h3>
      <ul class="res-info">
        <li @click="selectDate" class="res-select">
          <label>预约日期</label>
          <div class="placeholder">
            <p class="value" v-if="day">{{ day }}</p>
            <p class="value2" v-else>请选择</p>
            <span><img src="../assets/img/arrow-right.png" alt=""></span>
          </div>
        </li>
        <li @click="selectTime" class="res-select">
          <label>预约时段</label>
          <div class="placeholder">
            <p class="value" v-if="time">{{ time }}</p>
            <p class="value2" v-else>请选择</p>
            <span><img src="../assets/img/arrow-right.png" alt=""></span>
          </div>
        </li>
        <li class="res-select">
          <label>预约人</label>
          <div class="placeholder">
            <p class="value">{{ nameStr(name) }}</p>
          </div>
        </li>
        <li class="res-select">
          <label>联系方式</label>
          <div class="placeholder">
            <p class="value">{{mobileStrPhone(mobile) }}</p>
          </div>
        </li>
        <li class="res-select">
          <label>证件号</label>
          <div class="placeholder">
            <p class="value">{{ idCardStr(idcard) }}</p>
          </div>
        </li>
        <li class="res-select" v-if="showCorpInfo">
          <label >企业名称</label>
          <div class="placeholder" style="text-align: right;margin-right: 2px ;">
            <input type="text" style="text-align: right;margin-right: 2px;font-size:16px ;width: 250px" class="value" placeholder="企业名称需与办事材料保持一致!" v-model="stCorpName" size="27px">
          </div>
        </li>
        <li class="res-select" v-if="showCorpInfo">
          <label>企业统一社会信用码</label>
          <div class="placeholder">
            <input type="text" class="value" placeholder="非必填" style="text-align: right;font-size:16px"  oninput="value=value.replace(/[^0-9A-Z]/g,'');" maxlength="18" minlength="18" v-model="stCorpCreditCode">
          </div>
        </li>
        <!--     预约人数选择入口  -->
        <div v-show="numButtonShow">
          <h3 class="title">预约人数</h3>
          <li @click="userNumConfig" class="res-select" >
            <label>请选择</label>
            <div class="placeholder">
              <p class="value" v-if="columnsuser">{{ columnsuser }}</p>
              <p class="xuanze" v-else >选择</p>
            </div>
          </li>
        </div>
      </ul>
      <!--     预约人员信息添加入口   -->
      <div style="text-align: center;"  class="jump"  v-show="idCardButtonShow"   @click="openIdCard">
        <div style="float: left;margin-left: 33%">
          <span style="text-align: center;" >新增人员</span>
        </div>
        <div style="float: left;margin-left: 2.7rem">
              <span >
        <van-icon style="margin-right: 1.5rem;margin-top: 0.3rem;" name="add"></van-icon>
      </span>
        </div>
      </div>
      <!--    人员信息显示  -->
      <div style=" padding-top: 0rem;padding-bottom: 0.5rem;height: auto;overflow: auto;top:60px;bottom:30px;">
        <van-list  class="reservation-list" style="padding-right: 0.6rem;padding-top: 0.3rem;">
          <li v-for="item in idCardList" :key="item.index" style=" display: flex;justify-content: space-around;align-items:center;background-color:#F8F4EC ;border-style:solid;border-width:3px;border-color: white;height: 50px;">
            <span><van-icon name="idcard" size="21px" style="padding-top: 0.2rem"></van-icon></span>
            <span class="matter">{{ item.name }}</span>
            <div>
              <p class="matter">证件号:{{ idCardStr(item.idCard) }}</p>
              <p class="matter">手机号:{{ mobileStrPhone(item.mobile) }}</p>
            </div>
            <span @click="delIdCard(item.idCard)" ><van-icon name="clear" size="23px" style="padding-top: 0.2rem"/></span>
          </li>
        </van-list>
      </div>
    </div>

    <van-overlay :show="overlayShow" @click="show = false" >
      <div class="loading">
        <van-loading text-size="25px" color="#cbb486" size="100px" :vertical="true" style="color: #cbb486">
          <span style="color: #cbb486">正在提交...</span>
        </van-loading>
      </div>
    </van-overlay>
    <!-- 底部 -->
    <div class="reservation-foot">
      <span @click="submit" class="reservation-btn" >提交</span>
    </div>

    <!-- 选择弹出框 -->
    <transition name="fade">
      <div @click.self="closeSelect" v-show="showSelectTime" class="dialog">
        <div class="dialog-main">
          <div class="dialog-title">
            <p>选择时间段</p>
            <span @click="closeSelect" class="close">
                <img src="../assets/img/close.png" alt="">
              </span>
          </div>
          <div class="dialog-content">
            <ul v-show="showTimeList" class="time-list">
              <li v-for="item in timeList" :key="item.resourceId" @click.stop="checkTime(item.nmReservationRemain,item.time,item.resourceId)" class="time-item" :class="isZero(item.nmReservationRemain)">
                <p>{{item.time}}</p>
                <div v-if="item.nmReservationRemain>3">
                  <p class="remain">充足</p>
                </div>
                <div v-if="item.nmReservationRemain<=3">
                  <p class="remain">剩余{{ item.nmReservationRemain }}个</p>
                </div>
              </li>
            </ul>
            <div class="tips" v-show="!showTimeList">请先选择预约日期</div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 选择日期弹出框 -->
    <transition name="fade">
      <div @click.self="closeSelectDate" v-show="showSelectDate" class="dialog">
        <div class="dialog-main">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="选择年月日"
            :min-date="minDate"
            :max-date="maxDate"
            @change="changeFn()"
            @confirm="checkDate"
            @cancel="closeSelectDate"
          />
          <div class="dialog-content">

          </div>
        </div>
      </div>
    </transition>
    <!-- '红途'选择人数 -->
    <transition name="fade">
      <div @click.self="closeSelectDate01" v-show="numShow" class="dialog01">
        <div class="dialog-main">
          <van-picker
            :default-index="2"
            show-toolbar
            :columns="columns"
            @cancel="onCancel"
            @confirm="onConfirm"
          />
          <div class="dialog-content">
          </div>
        </div>
      </div>
    </transition>
    <!--'红途'添加身份弹出框 -->
    <transition name="fade">
      <div @click.self="closeSelectDate02" v-show="idCardShow" class="dialog01">
        <div class="dialog-main">
          <div style="text-align: center">
            <a style="float: left;font-size: medium;color: #cbb486" @click="closeSelectDate02">关闭</a>
            <span style="font-size: medium">新增人员</span>
            <a style="float: right;font-size: medium;color: #cbb486" @click="addIdCard">确认</a>
          </div>
          <ul class="res-info">
            <li  class="res-select02">
              <label style="color: black">证件类型 : </label>
              <div class="placeholder">
                <input  type="text" style="color: black" value="身份证" readonly="true">
                <span><img src="../assets/img/arrow-right.png" alt=""></span>
              </div>
            </li>
            <li class="res-select02">
              <label><van-icon name="user-circle-o" /></label>
              <div class="placeholder">
                <input v-model="idCardUserName" type="text" class="value" placeholder="请输入姓名" required="required">
              </div>
            </li>
            <li class="res-select02" >
              <label><van-icon name="credit-pay" /></label>
              <div class="placeholder">
                <input  v-model="idCard" type="text" class="value" oninput="value=value.replace(/[^0-9A-Z]/g,'');" maxlength="18" minlength="18" placeholder="请输入证件号(X为大写）" >
              </div>
            </li>
            <li class="res-select02" >
              <label><van-icon name="phone-circle-o"></van-icon></label>
              <div class="placeholder">
                <input  v-model="idCardUserPhone" type="text" class="value" placeholder="请输入手机号" >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </transition>

  </div>
  <!--    ==========================================    -->
</template>

<script>
  import {  Dialog } from "vant";
  import {authCreditCode,userPhoneAuth} from "../utils/auth";
  import {mobileStrPhoneUp} from "../utils/coverUp";
  import {isEmpty} from "../utils";
  import {jumpHandle} from "../components/jumpUtils";

  export default {
    components: {
      [Dialog.name]: Dialog
    },
    data () {
      return {
        //遮罩开关
        overlayShow: false,
        auth:false,
        idCardList: [],
        idCard: '',
        idCardUserName: '',
        idCardUserPhone: '',
        proxy: '',
        proxyMax:'',
        columnsuser: '',
        columnsuserNum:'',
        columns: [],
        idCardButtonShow: false,
        idCardShow: false,
        numButtonShow: false,
        numShow: false,
        //提交按钮开关
        isDisable: false,
        showCorpInfo: false,
        stCorpName: '', // 企业名称
        stCorpCreditCode: '', // 信用代码
        IfNeedCompanyInformation: '',
        viewShow: false,
        reservableDays: 0,
        showSelectTime: false,
        showSelectDate: false,
        time: '',
        day: '',
        minDate: new Date(new Date().setDate(new Date().getDate()+1)) ,
        maxDate: new Date(new Date().setDate(new Date().getDate()+1)) ,
        currentDate: new Date(),
        changeDate: new Date(),
        data: {},
        timeList: [],
        resourceId: '',
        placeId: '',
        id: '',
        itemCode: '',
        placeName: '',
        workTime: '',
        placeAddress: '',
        termName: '',
        itemName: '',
        itemId: '',
        windowId: '',
        access_token: '',
        idCardNo: '',
        userName: '',
        mobile: '',
        name: '',
        idcard: '',
        source: '',
        reference: '',
        //企业云的两个Token
        app_token:'',
      }
    },
    methods: {
      delIdCard(item){
        Dialog.confirm({
          title: "提示",
          message: "是否确定删除该信息?"
        }).then(() =>{
          for(var i = 0; this.idCardList.length>i;i++){
            if(this.idCardList[i].idCard === item){
              this.idCardList.splice(i,1)
            }
          }
        })
          .catch(() => {});
      },
      forEachProxyMax () {
        for (var i = 0; i < this.proxyMax; i++) {
          this.columns.push(i + 1 + '人')
        }
      },
      onConfirm (value, index) {
        this.columnsuser = value
        this.columnsuserNum = index+1
        this.numShow = false
      },
      onCancel () {
        this.numShow = false
      },
      async addIdCard() {
        if(this.idCardUserName===""){
          this.$toast("姓名不能为空")
          return
        }

        const authUserPhone = await userPhoneAuth(this.idCardUserPhone);
        if(authUserPhone!==""){
          this.$toast(authUserPhone)
          return
        }
        await this.idCardVerification()
        if (this.auth === true) {
          let idCardfrom =
            {
              idCard: this.idCard,
              name: this.idCardUserName,
              mobile: this.idCardUserPhone
            };
          this.idCardList.push(idCardfrom);
          this.idCardShow = false;
          this.closeIdCardFrom();
        } else {
          this.$toast('身份证号与姓名不匹配')
        }
      },
      /* 设置可预约时长 */
      slectDate(num) {
        let now = new Date()
        let currentHour = now.getHours()
        let currentMinute = now.getMinutes()
        /* 8:30前，如果可约天数大于1则减去1天，可约天数为1不变 */
        if (currentHour < 8 || (currentHour === 8 && currentMinute < 30) ) {
          num = num > 1 ? num - 1 : num
        }
        let curDate = (new Date()).getTime()
        let last = num * 24 * 3600 * 1000
        let first = 24 * 3600 * 1000
        let maxDate = curDate + last
        let minDate = curDate + first
        this.maxDate = new Date(maxDate)
        this.minDate = new Date(minDate)
      },
      /* 对idCard加密 */
      idCardStr (str) {
        if (str === null || str === 'undefined' || str === '') return null
        if (str.length !== 0) {
          return str.substring(0, 0) + '**************' + str.substring(14, str.length)
        } else {
          // return str.substring(0, str.length - 1) + '****'
          return null
        }
      },
      mobileStrPhone(str){
        return  mobileStrPhoneUp(str)
      },
      /* 对姓名加密 */
      nameStr (str) {
        if (str === null || str === 'undefined' || str === '') return null
        if (str.length !== 0) {
          return new Array(str.length).join('*') + str.substr(-1)
        } else {
          return null
        }
      },
      openIdCard () {
        if(this.proxyMax>this.idCardList.length){
          this.idCardShow = true
        }else{
          this.$toast('最多可添加'+ this.proxyMax +'人')
        }
      },
      userNumConfig () {
        this.numShow = true
      },
      selectTime () {
        this.showSelectTime = true
      },
      selectDate () {
        this.showSelectDate = true
      },
      closeSelect () {
        this.showSelectTime = false
      },
      closeSelectDate () {
        this.showSelectDate = false
      },
      closeSelectDate01 () {
        this.numShow = false
      },
      closeIdCardFrom () {
        this.idCard = ''
        this.idCardUserName = ''
        this.idCardUserPhone = ''
      },
      closeSelectDate02 () {
        this.idCardShow = false
        this.closeIdCardFrom()
      },
      checkTime (val, start, id) {
        if (val > 0) {
          this.resourceId = id
          this.time = start
          this.closeSelect()
        } else {
          this.$toast('当前时间段已约满')
        }
      },
      changeFn () { // 值变化是触发
        this.changeDate = this.currentDate // Tue Sep 08 2020 00:00:00 GMT+0800 (中国标准时间)
      },

      // creditCode () { // 校验企业信用代码
      //   var code = this.stCorpCreditCode
      //   var patrn = /^[0-9A-Z]+$/
      //   // 18位校验及大写校验
      //   if ((code.length !== 18) || (patrn.test(code) === false)) {
      //     console.info('不是有效的统一社会信用编码！')
      //     return false
      //   } else {
      //     var Ancode // 统一社会信用代码的每一个值
      //     var Ancodevalue // 统一社会信用代码每一个值的权重
      //     var total = 0
      //     var weightedfactors = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28] // 加权因子
      //     var str = '0123456789ABCDEFGHJKLMNPQRTUWXY'
      //     // 不用I、O、S、V、Z
      //     for (var i = 0; i < code.length - 1; i++) {
      //       Ancode = code.substring(i, i + 1)
      //       Ancodevalue = str.indexOf(Ancode)
      //       total = total + Ancodevalue * weightedfactors[i]
      //       // 权重与加权因子相乘之和
      //     }
      //     var logiccheckcode = 31 - total % 31
      //     if (logiccheckcode === 31) {
      //       logiccheckcode = 0
      //     }
      //     var Str = '0,1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,T,U,W,X,Y'
      //     var ArrayStr = Str.split(',')
      //     logiccheckcode = ArrayStr[logiccheckcode]
      //
      //     var checkcode = code.substring(17, 18)
      //     if (logiccheckcode !== checkcode) {
      //       console.info('不是有效的统一社会信用编码！')
      //       return false
      //     } else {
      //       console.info('yes')
      //     }
      //     return true
      //   }
      // },
      /* 获取用户选择的预约日期以及获取资源列表 */
      async checkDate(value) {
        try {
          /* 判断当前时间小于8:30，且可约天数为1的，不调用接口直接返回空列表 */
          let now = new Date()
          let currentHour = now.getHours()
          let currentMinute = now.getMinutes()
          if (currentHour < 8 || (currentHour === 8 && currentMinute < 30) ) {
            if(this.reservableDays <= 1) {
              this.$toast('暂无可预约时间段')
              this.time = ''
              this.timeList = []
              this.resourceId = ''
              return
            }
          }
          var year = value.getFullYear()
          var month = (value.getMonth() + 1 + '').length === 1 ? ('0' + (value.getMonth() + 1)) : (value.getMonth() + 1)
          var date = (value.getDate() + '').length === 1 ? ('0' + value.getDate()) : value.getDate()
          this.day = year + '-' + month + '-' + date
          const res = await this.$axios.post('/dev/AppFController/getResourceList', {
            itemCode: this.itemCode,
            placeId: this.placeId,
            stDay: this.day,
            itemId:this.itemId
          })
          if (res.status === '200') {
            if (res.data.length === 0) {
              this.$toast('暂无可预约时间段')
              this.time = ''
              this.timeList = []
              this.resourceId = ''
            } else {
              this.time = ''
              this.timeList = res.data
              this.closeSelectDate()
            }
          } else {
            this.$toast(res.message)
          }
        } catch (e) {
          console.log('获取资源error')
          // this.$toast('error')
        }
      },
      /* 通知界面 */
      toNotice() {
        this.$router.push('/notice')
      },
      /* 保存预约记录 */
      async submit() {
        if(this.isDisable){
          return ;
        }
        this.isDisable = true
        if (this.resourceId) {
          let data = {
            resourceId: this.resourceId,
            source: this.source,
            itemId: this.itemId,
            proxy: this.proxy
          }
          if(this.proxy === 'REAL_NAME'){
            data.proxyList = this.idCardList
          }else if (this.proxy ==='NON_REAL_NAME'){
            data.proxyNumber = this.columnsuserNum
          }
          if (this.showCorpInfo) { // 需要填写企业信息
            if (!this.stCorpName) {
              this.$toast('请填写企业信息')
              this.isDisable = false
              return false
            }
            if (this.stCorpCreditCode && !authCreditCode (this.stCorpCreditCode)) {
              this.$toast('统一社会信用代码错误')
              this.isDisable = false
              return false
            }
            data.stCorpName = this.stCorpName
            data.stCorpCreditCode = this.stCorpCreditCode
          }
          this.overlayShow = true;
          // alert(1);
          const res = await this.$axios.post('/dev/AppUController/saveRecord', data)
          // alert(2)
          if (res.status === 200) {
            this.overlayShow = false;
            this.$toast('预约成功');
            this.$router.push({
              path: '/successful',
              query: {
                recordId:res.data,
              }
            });
            this.isDisable = false
          } else if (res.status === '403') {
            this.overlayShow = false;
            this.jumpToMobile()
          } else {
            this.isDisable = false;
            this.overlayShow = false;
            this.$toast(res.msg)
          }
        } else {
          this.isDisable = false;
          this.$toast('请先选择预约日期和时间段')
        }
      },
      async idCardVerification(){
        try {
          this.auth = false;
          const res = await this.$axios.post('/forwarder/authentication/authPerson',{
            idCard :this.idCard,
            name:this.idCardUserName,
            mobile:this.idCardUserPhone
          })
          if(res.status===200){
            this.auth = true
          }
        }catch (e) {
          console.log(e)
        }
      },
      /* 获取办理点名称 */
      async getItemInfo () {
        try {
          const res = await this.$axios.post('/dev/AppFController/getItemInfo', {
            stPlaceId: this.placeId,
            stTermCode: this.itemCode
          })
          if (res.status === 200) {
            this.itemName = res.data.stTermName;
            this.itemId = res.data.stTermId;
            this.proxyMax = res.data.proxyMax;
            // res.data.proxy = 'NON_REAL_NAME';
            this.proxy = res.data.proxy;
            if(res.data.proxy === 'REAL_NAME'){
              this.idCardButtonShow = true
            }else if(res.data.proxy === 'NON_REAL_NAME'){
              this.forEachProxyMax()
              this.numButtonShow = true
            }else{
              this.idCardButtonShow = false
              this.numButtonShow = false
            }
            if (res.data.ifNeedCompanyInformation === '1') {
              this.showCorpInfo = true
            }
          } else {
            this.$toast(res.message)
          }
        } catch (e) {
          console.log('获取办理点名称 error')
          // this.$toast('error')
        }
      },
      /* 通过位置ID或窗口ID获取位置类型网址url */
      async getPlaceTypeUrlByPlaceIdOrWindowId() {
        // from=1 不需要跳转留在本页
        if (this.$route.query.from === '1' || sessionStorage.getItem('from') === '1') {
          // alert('from in')
          this.viewShow = true
          if (this.idcard === null || this.idcard === undefined || this.idcard === '' || this.idcard === 'null') {
            // alert('session in')
            if (this.access_token !== undefined && this.access_token !== null && this.access_token !== '') {
              // alert('token in')
              await this.getUserInfoByToken()
            } else if(!isEmpty(this.app_token)) {
              await this.getUserInfoByAppToken()
            }else {
              if(this.reference==='enterprise'){
                //jumpToEnterpriseLogin
                this.$toast('用户信息获取失败')
                return
              }else {
                this.jumpToMobile()
                return
              }
            }
          }
          // this.getUserInfoByToken() // 用于测试环境，正式环境删除
          await this.getPlaceDetail()
          return
        }

        try {
          let temporaryReference = (isEmpty(this.reference)) ? 'app':this.reference
          const res = await this.$axios.post('/dev/AppFController/getPlaceTypeUrlByPlaceIdOrWindowId', {
            windowId: this.windowId,
            reference: temporaryReference
          })
          if (res.status === '200') {
            this.redirectType = res.pattern
            if (this.redirectType === '1') {
              let jumpFlag = sessionStorage.getItem('' + this.windowId)
              if (jumpFlag === null || jumpFlag === undefined || jumpFlag === '') {
                sessionStorage.setItem('' + this.windowId, '1')
                jumpHandle(res.pageType,temporaryReference,res.url)
              } else {
                sessionStorage.removeItem('' + this.windowId)
                window.history.go(-1)
              }
            } else if (this.redirectType === '2') {
              this.viewShow = true
              document.title = '填写预约信息'
              if (!this.idcard) { // 正式环境
                if (this.$route.query.access_token) {
                  this.access_token = this.$route.query.access_token
                  this.getUserInfoByToken()
                } else if(!isEmpty(this.app_token)) {
                  await this.getUserInfoByAppToken()
                }else{
                  if(this.reference==='enterprise'){
                    //jumpToEnterpriseLogin
                    this.$toast('用户信息获取失败')
                    return
                  }else {
                    this.jumpToMobile()
                    return
                  }
                }
              }
              // this.getUserInfoByToken() // 用于测试环境
              this.getPlaceDetail()
            } else {
              this.viewShow = true
              document.title = '填写预约信息'
              this.$toast('该办理点暂不提供预约服务')
              this.finishedText = '该办理点暂不提供预约服务'
            }
          } else {
            this.viewShow = true
            document.title = '填写预约信息'
            this.$toast('该办理点暂不提供预约服务')
            this.finishedText = '该办理点暂不提供预约服务'
          }
        } catch (e) {
          console.log('获取跳转类型error')
          // this.$toast('error')
        }
      },
      /* 获取地点的详细信息 */
      async getPlaceDetail() {
        try {
          const res = await this.$axios.post('/dev/AppFController/getPlaceDetailByPlaceIdOrWindowId', {
            windowId: this.windowId
          })
          if (res.status === '200') {
            this.placeName = res.placeName
            this.workTime = res.workTime
            this.placeAddress = res.placeAddress
            this.placeId = res.placeId
            this.getTimeByPlaceIdAndTermCode()  // 暂时不调用该接口获取可约天数 直接先获取13~14天
            this.getItemInfo()
          } else {
            this.$toast('该办理点暂不提供预约服务')
          }
        } catch (e) {
          console.log('获取地点的详细信息 error')
          // this.$toast('error')
        }
      },
      /* 获取可预约的天数 */
      async getTimeByPlaceIdAndTermCode() {
        try {
          const res = await this.$axios.post('/dev/AppFController/getTimeByPlaceIdAndTermCode', {
            itemCode: this.itemCode,
            placeId: this.placeId
          })
          if (res.status === '200') {
            if(res.time>14)this.reservableDays=14;
            else this.reservableDays=res.time;
            this.slectDate(this.reservableDays);
          } else {
            this.$toast('该事项暂无可约时间段')
          }
        } catch (e) {
          console.log('获取可预约的天数error')
          // this.$toast('error')
        }
      },
      /* 获取用户信息 */
      async getUserInfoByToken() {
        try {
          const res = await this.$axios.post('/forwarder/login/getUserInfoByToken', {
            access_token: this.$route.query.access_token
          })
          if (res.status === '200') {
            this.idcard = res.idCardNo
            this.mobile = res.mobile
            this.name = res.userName
            sessionStorage.setItem('idCardNo', res.idCardNo)
            sessionStorage.setItem('mobile', res.mobile)
            sessionStorage.setItem('userName', res.userName)
          }
        } catch (e) {
          console.log('获取用户信息error')
          // this.$toast('error')
        }
      },
      isZero(val) {
        return val ? '' : 'zero'
      },
      jumpToMobile() {
        window.location.href = '/forwarder/redirect/jumpToMobile?itemCode=' + this.itemCode + '&placeId=' + this.windowId
      },
      async getUserInfoByAppToken() {
        try {
          const res = await this.$axios.post('/forwarder/enterprise/getUserInfoByAppToken', {
            appToken: this.app_token
          })
          if (res.status === '200') {
            this.idcard = res.data.idCard
            this.mobile = res.data.phone
            this.name = res.data.realName
            sessionStorage.setItem('idCardNo', res.data.idCard)
            sessionStorage.setItem('mobile', res.data.phone)
            sessionStorage.setItem('userName', res.data.realName)
          }
        } catch (e) {
          console.log('企业获取用户信息失败')
        }
      }
    },
    computed: {
      showTimeList() {
        return this.timeList.length > 0
      }
    },
    async created() {
      if (this.$route.query.from) {
        sessionStorage.setItem('from', this.$route.query.from)
      }

      /*
       * 标记跳转来源
       * 微信： reference = mini_wechat
       * 支付宝: reference = mini_alipay
       * 地图: reference = map_gov
       */
      if (this.$route.query.reference) {
        this.reference = this.$route.query.reference
        sessionStorage.setItem('reference', this.$route.query.reference)
      }
      this.windowId = this.$route.query.placeId
      this.itemCode = this.$route.query.itemCode
      this.access_token = this.$route.query.access_token
      this.mobile = sessionStorage.getItem('mobile')
      this.name = sessionStorage.getItem('userName')
      this.idcard = sessionStorage.getItem('idCardNo')
      document.title = ''
      /* 判断预约来源 ：0002（随申办） 0003（微信小程序） 0004（支付宝小程序）0007企业云 */
      this.reference = sessionStorage.getItem('reference')
      if (this.reference === 'mini_wechat') {
        this.source = '0003'
      } else if (this.reference === 'mini_alipay') {
        this.source = '0004'
      } else if (this.reference === 'enterprise') {
        this.source = '0007'
      } else {
        this.source = '0002'
      }
      if (this.reference === 'enterprise' && isEmpty(this.idcard)) {
        if (!isEmpty(sessionStorage.getItem('app_token')) || !isEmpty(this.$route.query["app-token"])) {
          if (!isEmpty(sessionStorage.getItem('app_token'))) {
            this.app_token = sessionStorage.getItem('app_token')
          }
          if (!isEmpty(this.$route.query["app-token"])) {
            this.app_token = this.$route.query["app-token"]
          }
          await this.getUserInfoByAppToken()
        } else {
          this.$toast('用户信息获取失败')
        }
      }
      /*****************/
      if (this.reference !== 'enterprise') {
        await this.getUserInfoByToken()
      }
      await this.getPlaceTypeUrlByPlaceIdOrWindowId()
    }
  }
</script>

<style lang="less">
  #reservation {
    .jump01 {
      width: 1.9rem /* 95/50 */;
      height: .8rem /* 40/50 */;
      font-size: .48rem /* 24/50 */;
      line-height: .8rem /* 40/50 */;
      text-align: center;
      color: @theme-color;
      border: .04rem /* 2/50 */ solid @theme-color;
      border-radius: .1rem /* 5/50 */;
      margin: 0 .6rem /* 30/50 */;
      border-radius: .06rem /* 3/50 */;
    }
    .jump {
      display:block;
      width: 92%;
      height: 1.8rem /* 40/50 */;
      font-size: .98rem /* 24/50 */;
      text-align: center;
      color: @theme-color;
      border: .1rem /* 2/50 */ solid @theme-color;
      border-radius:10px /* 5/50 */;
      margin: 0 .6rem /* 30/50 */;
    }
    .main {
      padding-top: 0rem;
      overflow: auto;
    }

    .res-content {
      padding: .4rem /* 20/50 */;
      line-height: 1.2rem /* 60/50 */;
      background-color: #fff;

      .matter {
        font-size: .72rem /* 36/50 */;
        font-weight: 700;
        color: rgba(0, 0, 0, 1);
      }

      .location {
        color: rgba(0, 0, 0, .5);
        font-size: .64rem /* 32/50 */;
      }

      .address {
        color: rgba(0, 0, 0, .5);
        font-size: .48rem /* 24/50 */;
      }

      .res-item {
        color: rgba(0, 0, 0, .5);
        font-size: .56rem /* 28/50 */;

        .item-tit {
          font-size: .56rem /* 28/50 */;
          color: rgba(0, 0, 0, 1);
          display: flex;
          align-items: center;

          .icon {
            width: .88rem /* 44/50 */;
            height: .88rem /* 44/50 */;
            margin-right: .32rem /* 16/50 */;
          }
        }

        a {
          display: flex;
          align-items: center;
          justify-content: space-between;

          span {
            width: .34rem /* 17/50 */;
            height: .56rem /* 28/50 */;
            margin-left: .4rem /* 20/50 */;
          }

          p {
            flex: 1;
          }
        }
      }
    }

    .title {
      color: rgba(0, 0, 0, 1);
      font-size: .68rem /* 34/50 */;
      padding: 0 .4rem /* 20/50 */;
      line-height: 2rem /* 100/50 */;
      background-color: #f7f7f7;
    }

    .res-info {
      li {
        border-bottom: .02rem /* 1/50 */ solid #f0f0f0;
      }

    }
    .res-select02 {
      height: 1.8rem /* 90/50 */;
      display: flex;
      align-items: center;
      font-size: .68rem /* 34/50 */;
      justify-content: space-around;
      padding: 0 .4rem /* 20/50 */;
      color: #9c9c9c;
      background-color: #fff;
      .placeholder {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .value {
          color: #333;
        }

        .value2 {
          color: rgba(0, 0, 0, .5);
          font-size: .64rem /* 32/50 */;
        }
        .xuanze{
          color:@theme-color ;
        }
        span {
          width: .34rem /* 17/50 */;
          height: .58rem /* 29/50 */;
          margin-left: .4rem /* 20/50 */;
        }
      }
    }
    .res-select {
      height: 1.8rem /* 90/50 */;
      display: flex;
      align-items: center;
      font-size: .68rem /* 34/50 */;
      justify-content: space-between;
      padding: 0 .4rem /* 20/50 */;
      color: #9c9c9c;
      background-color: #fff;

      .placeholder {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .value {
          color: #333;
        }

        .value2 {
          color: rgba(0, 0, 0, .5);
          font-size: .64rem /* 32/50 */;
        }
        .xuanze{
          color:@theme-color ;
        }
        span {
          width: .34rem /* 17/50 */;
          height: .58rem /* 29/50 */;
          margin-left: .4rem /* 20/50 */;
        }
      }
    }
    .dialog01{
      position: fixed;
      top: 0;
      z-index: 999;
      width: 100%;
      min-width: 320px;
      max-width: 750px;
      height: 100%;
      background-color: rgba(0,0,0,.4);
    }
    .dialog {
      position: fixed;
      top: 0;
      z-index: 999;
      width: 100%;
      min-width: 320px;
      max-width: 750px;
      height: 100%;
      background-color: rgba(0, 0, 0, .4);

      &-title {
        position: relative;
        width: 100%;
        font-size: .68rem /* 34/50 */;
        text-align: center;
        color: #333333;

        .close {
          position: absolute;
          top: 50%;
          right: .4rem /* 20/50 */;
          transform: translateY(-50%);
          width: .48rem /* 24/50 */;
          height: .48rem /* 24/50 */;
        }
      }

      &-main {
        position: absolute;
        bottom: 0;
        height: 40%;
        width: 100%;
        background-color: #fff;
        padding: .4rem /* 20/50 */;
      }

      &-content {
        position: relative;
        overflow: auto;
        height: 100%;
        padding-bottom: .8rem /* 40/50 */;

        .time-list {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;

          .time-item {
            width: 48%;
            text-align: center;
            color: #333333;
            margin-top: .4rem /* 20/50 */;
            font-size: .44rem /* 22/50 */;

            p {
              padding: .12rem /* 6/50 */ 0;
              background-color: #f5f6f6;
            }

            .remain {
              color: @theme-color;
            }
          }

          .zero {
            color: #aaa;

            .remain {
              color: #aaa;
            }
          }
        }

        .tips {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: .6rem /* 30/50 */;
          color: #aaa;
        }
      }
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
      opacity: 0;
    }

    .fade-enter-active .dialog-main, .fade-leave-active .dialog-main {
      transition: height .5s linear;
    }

    .fade-enter .dialog-main, .fade-leave-to .dialog-main {
      height: 0;
    }

    .van-picker__title {
      font-size: .68rem /* 34/50 */ !important;
    }

    .van-picker__cancel, .van-picker__confirm {
      font-size: .6rem /* 30/50 */ !important;
      color: @theme-color !important;
    }

    .van-picker-column__item {
      font-size: .6rem /* 30/50 */ !important;
    }

    .loading {
      position: fixed;
      z-index: 9999;
      width: 100%;
      height: 100%;
      /*background: rgba(255, 255, 255, 0.5);*/
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
